<template lang="pug">
.Character
  .bubble(v-show="safeMessage")
    vue-typer(
      :text="safeMessage || ' '"
      :repeat="0"
      :typeDelay="100"
      @completed="handleTypeCompleted"
    )
  .body
    img(v-if="type === 0" src="@/assets/character_default.svg")
    img(v-if="type === 1" src="@/assets/character_zeebra.svg")
    img(v-if="type === 2" src="@/assets/character_wizard.svg")
    img(v-if="type === 3" src="@/assets/character_hardboiled.svg")
    //- img(src="@/assets/character_positive.svg")
</template>

<script>
import { VueTyper } from 'vue-typer'
import { mapState } from 'vuex'
import soundService from '@/services/SoundService'

export default {
  name: 'km-character',
  components: {
    'vue-typer': VueTyper
  },
  props: ['message'],
  data() {
    return {
      isSpeechFinished: false,
      isTypeFinished: false,
      safeMessage: '',
      speechDelayTimerInstance: null
    }
  },
  watch: {
    message(value) {
      this.init(value)
      this.speech(value)
    },
    isCompleted() {
      if (this.isCompleted !== true) return
      this.$emit('onActionFinished')
    }
  },
  computed: {
    ...mapState('Character', {
      type: state => state.type
    }),
    isCompleted() {
      return soundService.isMuted
        ? this.isTypeFinished
        : this.isSpeechFinished && this.isTypeFinished
    }
  },
  methods: {
    init(message) {
      this.safeMessage = message
      this.isSpeechFinished = false
      this.isTypeFinished = false
    },
    speech(message) {
      if (this.speechDelayTimerInstance) {
        clearTimeout(this.speechDelayTimerInstance)
      }
      this.speechDelayTimerInstance = setTimeout(async () => {
        if (message === undefined) {
          soundService.stopSpeech()
          return
        }
        if (soundService.isMuted) return
        await soundService.speak(this.message)
        if (message === this.message) this.isSpeechFinished = true
      }, 500)
    },
    handleTypeCompleted() {
      this.isTypeFinished = true
    }
  },
  mounted() {}
}
</script>

<style lang="scss" scoped>
.Character {
  position: absolute;
  right: 50px;
  bottom: 0;
  width: 15%;

  .bubble {
    position: relative;
    padding: 10px;
    width: 100%;
    background: #fff;
    border-radius: 5px;

    &::after {
      position: absolute;
      display: block;
      left: calc(50% - 10px);
      bottom: -15px;
      content: '';
      width: 0;
      height: 0;
      border-left: 0px solid transparent;
      border-right: 15px solid transparent;
      border-top: 15px solid #fff;
    }
  }

  .body {
    width: 100%;
    animation-name: live;
    animation-duration: 2.828s;
    animation-timing-function: ease;
    animation-iteration-count: infinite;
    animation-direction: alternate;
    img {
      width: 100%;
      vertical-align: bottom;
    }
  }
}

@keyframes live {
  0% {
    transform: rotate(-2deg) translateY(40px);
  }

  100% {
    transform: rotate(2deg) translateY(20px);
  }
}
</style>
